<div class="auth-wrapper">

  <!-- LEFT -->
  <div class="auth-left">
    <div class="left-content">
      <h1>Welcome to Budget Bazaar</h1>
    </div>
  </div>

  <!-- RIGHT -->
  <div class="auth-right">
    <div class="auth-card shadow-lg">

      <h4 class="fw-bold mb-1">
        {{ isLogin ? 'Welcome Back' : 'Create Account' }}
      </h4>
      <p class="text-muted mb-3">
        {{ isLogin ? 'Login using Email OTP' : 'Register with Email OTP' }}
      </p>

      <!-- ================= LOGIN ================= -->
      <form *ngIf="isLogin && !showOtp" [formGroup]="loginForm" (ngSubmit)="sendLoginOtp()">

        <div class="mb-3">
          <label>Email</label>
          <input type="email" class="form-control" placeholder="example@email.com" formControlName="email">

          <small class="text-danger" *ngIf="loginForm.get('email')?.touched &&
           loginForm.get('email')?.errors?.['required']">
            Email is required
          </small>

          <!-- INVALID FORMAT -->
          <small class="text-danger" *ngIf="loginForm.get('email')?.touched &&
           loginForm.get('email')?.errors?.['email']">
            Enter a valid email format
          </small>

          <!-- DOMAIN NOT ALLOWED -->
          <small class="text-danger" *ngIf="loginForm.get('email')?.touched &&
           loginForm.get('email')?.errors?.['domainNotAllowed']">
            Only Gmail, Yahoo, or Zoho emails are allowed
          </small>
        </div>

        <button class="btn btn-primary w-100" type="submit" [disabled]="loginForm.invalid">
          Send OTP
        </button>
      </form>

      <!-- LOGIN OTP -->
      <form *ngIf="isLogin && showOtp" [formGroup]="otpForm" (ngSubmit)="verifyLoginOtp()">

        <label>Enter OTP</label>
        <input type="text" maxlength="4" inputmode="numeric" pattern="[0-9]*" class="form-control text-center otp-input"
          formControlName="otp" (keypress)="allowOnlyNumbers($event)">

        <small class="text-danger" *ngIf="otpForm.get('otp')?.touched && otpForm.get('otp')?.invalid">
          Enter 4 digit OTP
        </small>

        <div class="text-center mt-2">
          <button type="button" class="btn btn-link p-0" (click)="resendOtp()" [disabled]="resendDisabled">

            <span *ngIf="resendDisabled">
              Resend OTP in {{ resendTimer }}s
            </span>

            <span *ngIf="!resendDisabled">
              Resend OTP
            </span>
          </button>
        </div>

        <button class="btn btn-success w-100 mt-3" type="submit" [disabled]="otpForm.invalid">
          Verify & Login
        </button>
      </form>

      <!-- ================= REGISTER ================= -->
      <form *ngIf="!isLogin && !showOtp && !verifiedRegisterOtp" [formGroup]="registerForm"
        (ngSubmit)="sendRegisterOtp()">

        <div class="mb-2">
          <label>First Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="firstName">
        </div>

        <div class="mb-2">
          <label>Email <span class="text-danger">*</span></label>
          <input type="email" class="form-control" formControlName="email">
          <small class="text-danger" *ngIf="registerForm.get('email')?.touched &&
           registerForm.get('email')?.errors?.['required']">
            Email is required
          </small>

          <!-- INVALID FORMAT -->
          <small class="text-danger" *ngIf="registerForm.get('email')?.touched &&
           registerForm.get('email')?.errors?.['email']">
            Enter a valid email format
          </small>

          <!-- DOMAIN NOT ALLOWED -->
          <small class="text-danger" *ngIf="registerForm.get('email')?.touched &&
           registerForm.get('email')?.errors?.['domainNotAllowed']">
            Only Gmail, Yahoo, or Zoho emails are allowed
          </small>
        </div>

        <div class="mb-3">
          <label>Phone Number <span class="text-danger">*</span></label>
          <input type="tel" maxlength="10" class="form-control" formControlName="phoneNumber"
            (keypress)="allowOnlyNumbers($event)">
          <small class="text-danger" *ngIf="registerForm.get('phoneNumber')?.touched &&
           registerForm.get('phoneNumber')?.errors?.['required']">
            Phone number is required
          </small>

          <!-- LENGTH / PATTERN ERROR -->
          <small class="text-danger" *ngIf="registerForm.get('phoneNumber')?.touched &&
           registerForm.get('phoneNumber')?.errors?.['pattern']">
            Phone number must be 10 digits
          </small>
        </div>

        <button class="btn btn-primary w-100" type="submit" [disabled]="registerForm.invalid">
          Send OTP
        </button>
      </form>

      <!-- REGISTER OTP -->
      <form *ngIf="!isLogin && showOtp && !verifiedRegisterOtp" [formGroup]="otpForm" (ngSubmit)="verifyRegisterOtp()">

        <label>Enter OTP</label>
        <input type="number" maxlength="4" class="form-control text-center otp-input" formControlName="otp">
        <small class="text-danger" *ngIf="otpForm.get('otp')?.touched && otpForm.get('otp')?.invalid">
          Enter 4 digit OTP
        </small>
        <button class="btn btn-success w-100 mt-3" type="submit" [disabled]="otpForm.invalid">
          Verify OTP
        </button>
      </form>

      <!-- COMPLETE REGISTRATION -->
      <button *ngIf="verifiedRegisterOtp" class="btn btn-success w-100" (click)="saveRegistration()">
        Complete Registration
      </button>

      <!-- SWITCH -->
      <div class="text-center mt-3">
        <span class="text-muted">
          {{ isLogin ? 'New user?' : 'Already have account?' }}
        </span>
        <a class="text-primary fw-bold ms-1 cursor-pointer" (click)="toggleMode()">
          {{ isLogin ? 'Register' : 'Login' }}
        </a>
      </div>

    </div>
  </div>

  <!-- FOOTER -->
  <footer class="auth-footer">
    <div class="container-fluid h-100">
      <div class="row h-100 align-items-center">
        <div class="col-md-6 text-start ps-4">
          © {{ currentYear }}
          <a href="https://budgetbazaar.cktechsoln.in/" class="footer-link">
            Budget Bazaar
          </a>
        </div>

        <div class="col-md-6 text-end pe-4">
          Designed & Developed by
          <a href="https://cktechsoln.in/" target="_blank" class="footer-link">
            CKTech Solution Pvt Ltd
          </a>
        </div>
      </div>
    </div>
  </footer>

</div>